import script from "./ServerDatatable.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerDatatable.vue?vue&type=script&setup=true&lang=js"

import "./ServerDatatable.vue?vue&type=style&index=0&id=c45f96b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c45f96b6"]])

export default __exports__